export function projectStepReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_PROJECT_STEP":            
        case "UPDATE_PROJECT_STEP":
            let list = Object.assign({}, state);
            list[payload.project_step_id] = payload
        
            return list
       
        case "GET_PROJECT_STEPS":
            return payload
        case "DELETE_PROJECT_STEP":
            let list2 = Object.assign({}, state);
            
            delete list2[payload]
            return list2
        default:
            return state;
    }
    
}